import { createCustomSlice } from './customSlice';

export const todoSlice = createCustomSlice('todo');
